export const filterLabelMappings = {
  eventType: 'Event Type',
  status: 'Status'
};
